import { Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import { SectionLabelRow } from "web_myplann/Shared/Components/SectionLabelRow";

type Props = {
	title: string;
	actionLabel?: string;
	onAction?: () => void;
	children: ReactNode;
};

export const DashboardSection: FC<Props> = ({
	title,
	actionLabel,
	onAction,
	children,
}) => (
	<Stack>
		<SectionLabelRow
			title={title}
			actionLabel={actionLabel}
			onAction={onAction}
		/>
		<Stack bgcolor="background.paper">{children}</Stack>
	</Stack>
);
